
define('text!modules/reporting/campaigns/technology/templates/chart_ttip_daily.html',[],function () { return '<div class="chart-tooltip">\n  <dl>\n    <dd>{{ title }}</dd>\n  </dl>\n  <dl>\n    <dt>{{ key }}:</dt>\n    <dd>\n      <span>{{{value}}}</span>\n    </dd>\n  </dl>\n  <dl>\n    <dt>{{ info }}</dt>\n  </dl>\n</div>\n';});

